import { DateRangeFilterEnum as e } from "../types/date-range-filter-enum.js";
import { setDateSince as t } from "../utils/set-date-since.js";
import { setDateTill as n } from "../utils/set-date-till.js";
import { applyMaxInterval as r } from "./utils/apply-max-interval.js";
import { setActiveFilterValue as i } from "./utils/set-active-filter-value.js";
import { getDefaultCustomFilter as a } from "./utils/set-custom-filter.js";
import { useEffect as o, useMemo as s, useState as c } from "react";
import { getDate as l, setDateWithTimezone as u, toISOStringWithoutTimezone as d } from "@systemeio/util";
//#region src/date-picker/date-range-picker/use-date-range.ts
function f({ customFilters: f, date: p, intlLocale: m, maxInterval: h, minDate: g, timezone: _, getDefaultDate: v, onChange: y }) {
	let b = s(() => g ? d(g) : void 0, [g]), x = s(() => f || (b && _ ? [a(b, _)] : []), [
		f,
		b,
		_
	]), S = (e) => !m || !b || !e ? e : l(b) > l(e) ? b : e, C = S(p[0]), w = p[1], [T, E] = c(), [D, O] = c(), [k, A] = c([C ? u(C, _) : null, w ? u(w, _) : null]), [j, M] = c(C ? u(C, _) : null), [N, P] = c(w ? u(w, _) : null);
	o(() => {
		let e = C ? u(C, _) : null, t = w ? u(w, _) : null;
		A([e, t]), M(e), P(t);
	}, [
		C,
		w,
		_
	]), o(() => {
		!D || !_ || i({
			activeFilter: D,
			customFilters: x,
			setDateRange: A,
			timezone: _
		});
	}, [
		D,
		x,
		_
	]);
	let [F, I] = k;
	return {
		activeFilter: D,
		appliedDateSince: j,
		appliedDateTill: N,
		filterPresets: [
			e.Last30Days,
			e.ThisMonth,
			e.LastMonth,
			...x.map((e) => e.slug)
		],
		handleApply: () => {
			let [e, r] = k;
			e && r ? (M(e), P(r), E(D), t(e), n(r), y([d(e), d(r)])) : y([null, null]);
		},
		handleChange: (e) => {
			if (!Array.isArray(e)) return;
			O(void 0);
			let [t, n] = e, i = h ? r(t, n, h) : [t, n];
			A(i);
		},
		handleClear: () => {
			if (v) {
				let [e, t] = v(), n = S(e) ?? void 0, r = u(n, _), i = u(t, _);
				A([r, i]), M(r), P(i), y([d(r), d(i)]);
			} else A([null, null]), M(null), P(null), y([null, null]);
			O(void 0), E(void 0);
		},
		minAllowedDate: b,
		resetDraftRange: () => {
			A([j, N]), O(T);
		},
		selectedDateSince: F,
		selectedDateTill: I,
		setActiveFilter: O
	};
}
//#endregion
export { f as useDateRange };
